export const showApiKeyCreateModal = 'showApiKeyCreateModal';
export const showApiKeyRevealModal = 'showApiKeyRevealModal';
export const showApiKeyRevokeModal = 'showApiKeyRevokeModal';
export const revealedApiKey = 'revealedApiKey';
export const revokeTargetApiKey = 'revokeTargetApiKey';
